export default __webpack_public_path__ + "assets/56564689b7c75780da965380eb1bc94f.png";